import { render, staticRenderFns } from "./OrgTree.vue?vue&type=template&id=81081534"
import script from "./OrgTree.vue?vue&type=script&lang=js"
export * from "./OrgTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports